<template>
  <v-container class="ma-0 pa-0">
    <v-form ref="form" v-model="valid" lazy-validation>
      <h1>{{$t('labels.mobilephone')}}</h1>
      <p>{{$t('application.mobilephone.info')}}</p>
      <v-text-field
        v-shortkey="['enter']"
        @shortkey.native="nextStep"
        ref="phone"
        placeholder="0701234567"
        v-model="mobilephone"
        prepend-icon="$sl-mobile"
        :rules="[rules.required, rules.phone]"
      ></v-text-field>
      <p>{{$t('application.mobilephone.instructions')}}</p>
      <NextButton
        class="mt-3"
        @enter="nextStep"
        :isEnterSubmit="true"
        @click="nextStep"
        :isDisabled="isImitatingUser()"
      >{{$t('labels.confirmMobilePhone')}}</NextButton>
    </v-form>
  </v-container>
</template>

<script>
// Entryform for unknown user to become a apprentice
import API from '@/services/api.js'
import {mapActions, mapGetters} from 'vuex'
import {RulesMixin} from '@/components/mixins'
import NextButton from '@/components/Common/NextButton'
import get from 'lodash/get'

// @group Registration
// Styled Mobilephone component
export default {
  name: 'Mobilephone',

  mixins: [RulesMixin],

  data: () => ({
    mobilephone: '',

    valid: true
  }),
  components: {
    NextButton
  },

  created() {
    this.mobilephone = this.currentUser && this.currentUser.mobilephone ? this.currentUser.mobilephone : ''
  },

  watch: {
    'currentUser.mobilephone': function(newVal, oldVal) {
      this.mobilephone = this.currentUser.mobilephone
    }
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isImitatingUser'])
  },

  methods: {
     /**
     * @vuese
     * Used to go to the next step is form is valid and verify phone
     * @arg The argument is an integer representing application  id and params are the selected fields
     */
    nextStep() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', this.$t('errors.form-validation'))
        return
      }
      API.verifyPhone({
        data: {
          phone: this.mobilephone,
          firstName: get(this,'currentUser.firstName', ''),
          lastName: get(this,'currentUser.lastName', '')
        }
      })
        .then(response => {
          // Fire goToStep number 1
          // @arg The argument is a string representing mobile phone
          this.$emit('goToStep', {step: 1, mobilephone: this.mobilephone})
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('errors.save-failure'))
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style scoped>
</style>